import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  accountIcon: {
    color: theme.palette.owGray.main,
    overflow: "hidden",
  },
}));

export default useStyles;
